/*
 * @Description: 绩效管理
 * @Author: 杨志航<yangzhihang@372163.com>
 * @Date: 2021-11-05 14:07:34
 */

const ach = {
  // 绩效目标与结果
  getAchResultList: {
    url: '/fortune/achievements/getAchResultList',
    method: 'get'
  },
  getSearchData: {
    url: '/fortune/achievements/getSearchData',
    method: 'get'
  },
  updateAchResult: {
    url: '/fortune/achievements/updateAchResult',
    method: 'post'
  },
  updateAchResultAll: {
    url: '/fortune/achievements/editAch',
    method: 'post'
  },
  delAchResult: {
    url: '/fortune/achievements/delAchResult',
    method: 'post'
  },
  signAchResult: {
    url: '/fortune/achievements/signAchResult',
    method: 'post'
  },
  uploadAchResultFile: {
    url: '/fortune/achievements/upload',
    method: 'post'
  },
  getMonthList: {
    url: '/fortune/achievements/getMonthList',
    method: 'get'
  },
  copyAchTargetVerify: {
    url: '/fortune/achievements/copyAchTargetVerify',
    method: 'get'
  },
  copyAchTarget: {
    url: '/fortune/achievements/copyAchTarget',
    method: 'get'
  },
  // 年度目标管理
  getYearList: {
    url: '/fortune/achievements/getYearList',
    method: 'get'
  },
  saveAchYear: {
    url: '/fortune/achievements/saveAchYear',
    method: 'post'
  },
  getStfList: {
    url: '/fortune/achievements/getStfList',
    method: 'get'
  },
  delYear: {
    url: '/fortune/achievements/delYear',
    method: 'post'
  },
  // 绩效审批
  getAddStaffList: {
    url: '/fortune/achievements/getAddStaffList',
    method: 'get'
  },
  getAchievementsStaffList: {
    url: '/fortune/achievements/getStaffList',
    method: 'get'
  },
  updateStaffAuditNode: {
    url: '/fortune/achievements/updateStaffAuditNode',
    method: 'post'
  },
  addAchievementsStaff: {
    url: '/fortune/achievements/addStaff',
    method: 'post'
  },
  delAchievementsStaff: {
    url: '/fortune/achievements/delStaff',
    method: 'post'
  },
  applyApprovalTarget: {
    url: '/fortune/achAudit/applyApproval',
    method: 'post'
  },
  getApprovalList: {
    url: '/fortune/achAudit/getApprovalList',
    method: 'get'
  },
  delAchAudit: {
    url: '/fortune/achAudit/del',
    method: 'post'
  },
  getApprovalDetail: {
    url: '/fortune/achAudit/getApprovalDetail',
    method: 'get'
  },
  submitAchAudit: {
    url: '/fortune/achAudit/audit',
    method: 'post'
  },
  // 运营人员管理
  getAchOperationList: {
    url: '/CheckInStat/GetOperationList',
    method: 'get'
  },
  delAchOperation: {
    url: '/CheckInStat/DelOperation',
    method: 'post'
  },
  getAchOperationSearchList: {
    url: '/CheckInStat/GetOperationSearchList',
    method: 'get'
  },
  getAchImportOperation: {
    url: '/CheckInStat/ImportOperation',
    method: 'post'
  },
  // 等级销售搜模板管理
  getAchSaleTplList: {
    url: '/staffGradeSalesTemplate/getList',
    method: 'get'
  },
  delAchSaleTpl: {
    url: '/staffGradeSalesTemplate/del',
    method: 'post'
  },
  setAchSaleTpl: {
    url: '/staffGradeSalesTemplate/save',
    method: 'post'
  },
  // 试用期绩效考核审批
  getAchProbationReviewList: {
    url: '/staffProbationReview/getList',
    method: 'get'
  },
  getAchProbationReviewInfo: {
    url: '/staffProbationReview/getInfo',
    method: 'get'
  },
  setAchProbationReview: {
    url: '/staffProbationReview/save',
    method: 'post'
  },
  getGroupListByCompanyId: {
    url: '/group/getGroupListByCompanyId',
    method: 'get'
  },
  submitAchProbationReviewAudit: {
    url: '/staffProbationReview/audit',
    method: 'post'
  },
  delAchProbationReview: {
    url: '/staffProbationReview/del',
    method: 'post'
  },
  // 获取月度个人盈利看板
  getProfitReportList: {
    url: '/fortune/profitReport/getList',
    method: 'get'
  },
  // 导入成本和业绩
  importProfitReport: {
    url: '/fortune/profitReport/upload',
    method: 'post'
  },
  // 修改个人盈利信息
  editProfitReport: {
    url: '/fortune/profitReport/edit',
    method: 'post'
  },
  // 删除个人盈利信息
  delProfitReport: {
    url: '/fortune/profitReport/del',
    method: 'post'
  },
  // 获取个人盈利信息修改记录
  getProfitReportChangeLog: {
    url: '/fortune/profitReport/getChangeLog',
    method: 'get'
  },
  // 获取小程序入口开关
  getProfitReportMiniProgram: {
    url: '/fortune/profitReport/getIsOpen',
    method: 'get'
  },
  // 小程序入口开关设置
  setProfitReportMiniProgram: {
    url: '/fortune/profitReport/setIsOpen',
    method: 'post'
  },
  // 获取检索所需数据
  getProfitReportSearchData: {
    url: '/fortune/profitReport/getSearchData',
    method: 'get'
  },
  // 获取登录小程序的人员信息列表
  getProfitReportStaffList: {
    url: '/fortune/profitReport/getProfitStaffList',
    method: 'get'
  },
  // 登录小程序的人员解绑
  unbindProfitReportStaff: {
    url: '/fortune/profitReport/unbind',
    method: 'post'
  },
  // 获取事业群部门列表
  getProfitReportGroupSort: {
    url: '/fortune/profitReport/getGroupSort',
    method: 'get'
  },
  // 更改事业群名称及负责人
  updateProfitReportGroupName: {
    url: '/fortune/profitReport/updateGroupName',
    method: 'post'
  },
  // 更改部门名称及负责人
  updateProfitReportDepartName: {
    url: '/fortune/profitReport/updateDepartName',
    method: 'post'
  },
  // 事业群排序
  updateProfitReportGroupSort: {
    url: '/fortune/profitReport/updateGroupSort',
    method: 'post'
  },
  // 部门排序
  updateProfitReportDepartSort: {
    url: '/fortune/profitReport/updateDepartSort',
    method: 'post'
  },
  // 获取事业群下部门列表
  getProfitReportDepartSort: {
    url: '/fortune/profitReport/getDepartSort',
    method: 'get'
  },
  // 获取季度个人盈利看板
  getProfitReportQuarterlyList: {
    url: '/fortune/profitReportQuarterly/getList',
    method: 'get'
  },
}

export default ach
